module.exports = __webpack_public_path__ + "fonts/RundigsburgBold.fd27079.woff2";